<p-accordion [multiple]="item.multiple" [value]="expandedTabs">
  <p-accordion-panel *ngFor="let tab of item.tabs; index as i" [value]="i">
    <p-accordion-header>
      <div [innerHTML]="tab.translation_key||tab.heading | pipeFromText | translation| translationFromString | transformText :tab?.text_transform|safeHtml"></div>
    </p-accordion-header>
    <p-accordion-content>
      <div>
        <app-rendered
          [childview]="item.childview || childview"
          [paramprefix]="item.paramprefix"
          [info]="info"
          *ngFor="let it of tab.content"
          [item]="it" [arr]="tab.content"
          [data]="data"
          (deleteDataEvent)="delete($event)"
          (openViewEvent)="openView($event)"
          (moveHandler)="openMove()"
          (openLinkEvent)="openLink($event)"
          [collapsed]="tab.collapsed">
        </app-rendered>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
